
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Regular House Cleaning',
      description: 'Weekly, bi-weekly, or monthly cleaning services to keep your home consistently spotless.',
      price: 'Starting at $80',
      features: ['Dusting & vacuuming', 'Kitchen & bathroom cleaning', 'Floor mopping', 'Trash removal']
    },
    {
      icon: 'ri-brush-line',
      title: 'Deep Cleaning Service',
      description: 'Comprehensive top-to-bottom cleaning for a fresh start or special occasions.',
      price: 'Starting at $150',
      features: ['Inside appliances', 'Baseboards & windows', 'Light fixtures', 'Cabinet interiors']
    },
    {
      icon: 'ri-truck-line',
      title: 'Move-in/out Cleaning',
      description: 'Complete cleaning service for moving transitions, ensuring a fresh start.',
      price: 'Starting at $200',
      features: ['Empty home cleaning', 'All surfaces sanitized', 'Inside all cabinets', 'Ready for occupancy']
    },
    {
      icon: 'ri-hammer-line',
      title: 'Post-Construction Cleanup',
      description: 'Specialized cleaning after renovations or construction work.',
      price: 'Custom Quote',
      features: ['Dust removal', 'Paint & debris cleanup', 'Window cleaning', 'Final polish']
    },
    {
      icon: 'ri-window-line',
      title: 'Window Cleaning',
      description: 'Professional window cleaning for crystal clear views inside and out.',
      price: 'Starting at $60',
      features: ['Interior & exterior', 'Screen cleaning', 'Sill wiping', 'Streak-free finish']
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly Options',
      description: 'Green cleaning solutions that are safe for your family and pets.',
      price: 'No Extra Cost',
      features: ['Non-toxic products', 'Biodegradable cleaners', 'Safe for children', 'Environmentally responsible']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Cleaning Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From regular maintenance to deep cleaning, we offer comprehensive services 
            tailored to your specific needs and schedule.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-4">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              <div className="text-lg font-bold text-blue-600 mb-4">{service.price}</div>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
